import React from 'react';

export const FooterSpacer = () => (
    <div style={{ height: '100px' }}>

    </div>
)


// WEBPACK FOOTER //
// ./src/components/FooterSpacer.js/FooterSpacer.js